<template>
  <Modal v-model="rejectApplicationModal" width="600" :transfer="false" :mask-closable="false"
    :title="$t('key1002870')" @on-visible-change="rejectApplicationModalChange">
    <Form :model="rejectApplicationForm" ref="rejectApplicationForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width: 95%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1002787')" prop="auditRemarks">
            <Input v-model.trim="rejectApplicationForm.auditRemarks" :placeholder="$t('key1002868')"
              maxlength="200" show-word-limit type="textarea" :autosize="{minRows: 6, maxRows: 10}">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="cancelBtn">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="rejectApplicationBtn" :disabled="!rejectApplicationForm.auditRemarks">{{ $t('key1000987') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "rejectApplicationModal",
  mixins: [Mixin],
  props: {
    ymsMerchantId: {
      type: String,
      default: null
    },
    toExamineStatus: {
      type: Number,
      default: null
    },
    detailsData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      rejectApplicationModal: false,
      rejectApplicationForm: {
        auditRemarks: ''
      },
      ruleValidate: {
        auditRemarks: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002868'), trigger: 'blur'}
        ]
      },
      rejectApplicationTalg: false
    };
  },
  methods: {
    // 驳回
    rejectApplicationBtn() {
      let v = this;
      let params = {
        auditRemarks: v.rejectApplicationForm.auditRemarks,
        updateYmsSupplierAscriptionWarehouseBos: [],
        ymsMerchantId: v.ymsMerchantId
      };
      let url = '';
      switch (v.toExamineStatus) {
        // 入驻审核驳回
        case 1:
          params.supplierAuditStatus = 0;
          url = api.post_ymsSupplierMerchant_updateSupplierAuditInfo;
          break;
        // 工商信息审核驳回
        case 2:
          params.updateSupplierAuditStatus = 0;
          url = api.post_ymsSupplierMerchant_updateSupplierCompanyAuditInfo;
          break;
        // 店铺信息审核驳回
        case 4:
          params.updateSupplierStoreAuditStatus = 0;
          url = api.post_ymsSupplierMerchant_updateSupplierRegisterInfoAudit;
          break;
        // 账户信息审核驳回
        case 6:
          params = {
            payType: 2,
            name: v.detailsData?.name,
            payAccountNumber: v.detailsData?.payAccountNumber,
            idCard: v.detailsData?.idCard,
            updateSupplierPayAccountAuditStatus: 0,
            updateSupplierPayAccountAuditTime: v.$uDate.getCurrentTime('fulltime'),
            updateSupplierPayAccountAuditRemark: v.rejectApplicationForm.auditRemarks,
            ymsPayAccountId: v.detailsData?.ymsPayAccountId,
            supplierMerchantId: v.ymsMerchantId,
          }
          url = api.post_ymsSupplierMerchant_updateSupplierPayAccountAudit;
          break;
      }
      v.$refs['rejectApplicationForm'].validate((valid) => {
        if (valid) {
          v.axios.post(url, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002869'));
              v.rejectApplicationTalg = false;
              v.$emit('rejectApplicationUpdateData', true);
            }
          });
        }
      });
    },
    // 取消
    cancelBtn() {
      this.rejectApplicationModal = false;
      this.rejectApplicationTalg = true;
    },
    // 监听弹窗
    rejectApplicationModalChange(value) {
      if (value) {
        this.rejectApplicationTalg = false;
      } else {
        this.$refs['rejectApplicationForm'].resetFields();
        if (this.rejectApplicationTalg) {
          this.$emit('resetDetails', value);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>